// Always use absolute paths for better compatibility
const getAssetPath = (path: string): string => {
  // Ensure path starts with a forward slash
  return path.startsWith('/') ? path : `/${path}`;
};

export const assets = {
  models: {
    card: getAssetPath('cardglbgenesis.glb'),
  },
  textures: {
    lanyard: getAssetPath('lanyard.png'),
  },
};

// Log the resolved paths for debugging
console.log('Asset paths:', {
  cardGLB: assets.models.card,
  lanyard: assets.textures.lanyard,
  baseUrl: import.meta.env.BASE_URL,
  nodeEnv: process.env.NODE_ENV
});
